module.exports = __webpack_public_path__ + "static/media/24.484e86b9.jpg";